import { render, staticRenderFns } from "./ChangeSummaryHeader.vue?vue&type=template&id=31b8dfba&scoped=true&"
import script from "./ChangeSummaryHeader.vue?vue&type=script&lang=js&"
export * from "./ChangeSummaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSummaryHeader.vue?vue&type=style&index=0&id=31b8dfba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b8dfba",
  null
  
)

export default component.exports